/**
 * @typedef {Record<string, string | null | undefined>} CartAttributes
 */

/**
 * Safely parse JSON from a string.
 * @template T
 * @param {string | null | undefined} text
 * @param {T} fallback
 * @returns {T}
 */
function safeParseJSON(text, fallback) {
  try {
    return text ? JSON.parse(text) : fallback;
  } catch {
    return fallback;
  }
}

const LEADTIME_PREFIX = 'leadtime__';
let isSyncingCartAttributes = false;

window.syncCartAttributes = async function () {
  /** @type {Record<string, string | null>} */
  const leadtimeData = safeParseJSON(
    document.getElementById('leadtime-by-sku')?.textContent,
    {}
  );

  /** @type {Record<string, string | null>} */
  const existingAttributes = safeParseJSON(
    document.getElementById('cart-attributes')?.textContent,
    {}
  );

  /** @type {CartAttributes} */
  const delta = {};

  for (const key in leadtimeData) {
    if (existingAttributes[key] !== leadtimeData[key]) {
      delta[key] = leadtimeData[key];
    }
  }

  for (const key in existingAttributes) {
    if (key.startsWith(LEADTIME_PREFIX) && !(key in leadtimeData)) {
      delta[key] = null;
    }
  }

  if (Object.keys(delta).length === 0) {
    console.log('[Cart Sync] No changes detected');
    return;
  }

  if (isSyncingCartAttributes) return;
  isSyncingCartAttributes = true;
  
  console.log('[Cart Sync] Updating attributes:', delta);

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      attributes: delta,
    }),
  });

  isSyncingCartAttributes = false;
};

window.syncCartAttributes();

document.addEventListener('cart:update', () => {
  setTimeout(() => window.syncCartAttributes?.(), 1000);
});
